export const GET_MERCHANT_BASIC_INFO = `query GetMerchantBasicInfo {
    campaignPlans(first: 1) {
        edges {
            node {
                id
            }
        }
    }
    merchant{
        id
        defaultPaymentMethod {
            id
        }
        features
        hidePlans
        logo
        logoBgColor
        name
        onboarding {
            metadata
            tiktokSellerPortalPermissionsGranted
        }
        settingsObj
        tiktokBusinessAuthUrl
        tiktokShopAuthUrl
        tiktokPlan: plan(feature: TIKTOK_SHOP){
            id
        }

        youtubePlan: plan(feature: YOUTUBE_SHOPPING){
            id
        }

        tiktokShopConnections {
            edges {
                node {
                    sps {
                        score
                        tier
                        tierText
                        updatedAt
                        topIssuesSummary
                        metrics {
                            metricCode
                            dimension
                            metricName
                            score
                            status
                            statusText
                            value
                            valueUnit
                            excellentThreshold
                            poorThreshold
                            topReasonText
                            evaluateDurationDays
                            startEvaluationTime
                            endEvaluationTime
                        }
                        benefits {
                            benefitName
                            isUnlocked
                            unlockScore
                        }
                        topIssues {
                            rank
                            metricCode
                            description
                            evaluateDurationDays
                            startEvaluationTime
                            endEvaluationTime
                        }
                        dimensions {
                            name
                            score
                            status
                            statusText
                            weight
                        }
                    }
                }
            }
        }
    }
}`;
